// extracted by mini-css-extract-plugin
export var brand = "_ai-9";
export var compact = "_ai-6";
export var extraSmall = "_ai-7";
export var icon = "_ai-0";
export var large = "_ai-4";
export var light = "_ai-1";
export var medium = "_ai-5";
export var outline = "_ai-b";
export var primaryDark = "_ai-a";
export var primaryLight = "_ai-8";
export var primaryModern = "_ai-c";
export var success = "_ai-2";
export var successSolid = "_ai-3";